import { Component } from '@angular/core';

@Component({
    selector: 'app-mp-recent-activity',
    imports: [],
    templateUrl: './mp-recent-activity.component.html',
    styleUrl: './mp-recent-activity.component.scss'
})
export class MpRecentActivityComponent {}